export const WEBSITE_HOME_PAGE = 'https://www.racq.com.au';
export const HOME_PAGE = process.env.VUE_APP_HOME_PAGE ?? WEBSITE_HOME_PAGE;
export const CONTACT_JEOPARDY = process.env.VUE_APP_CONTACT_JEOPARDY ?? '/contact-us';
export const APPLE_PAY_SDK =
  process.env.VUE_APP_APPLE_PAY_SDK ?? 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
export const GOOGLE_PAY_GATEWAY_MERCHANT_ID = process.env.VUE_APP_GOOGLE_PAY_GATEWAY_MERCHANT_ID;
export const GOOGLE_PAY_MERCHANT_ID = process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID;
export const GOOGLE_PAY_MERCHANT_NAME = process.env.VUE_APP_GOOGLE_PAY_MERCHANT_NAME ?? 'RACQ';
export const GOOGLE_PAY_ENVIRONMENT = process.env.VUE_APP_GOOGLE_PAY_ENVIRONMENT ?? 'TEST';
